import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
    Button, Card, CardContent, CardHeader, Checkbox, CircularProgress, FormControlLabel,
    IconButton, Table, TableBody, TableCell, TableHead, TableRow,
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { ApiBackend } from "../../providers/apibackend";
import { Offer } from "../../model/Offer";

const ManageOffers = () => {
    const history = useHistory();
    const [offers, setOffers] = useState(null as Offer[]);
    const [includeArchived, setIncludeArchived] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        new ApiBackend().listOffers(includeArchived).then((res) => {
            setOffers(res || []);
            setLoading(false);
        });
    }, [includeArchived]);

    return (
        <Card>
            <CardHeader title="Hantera erbjudanden" />
            <CardContent>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                    <FormControlLabel
                        control={<Checkbox checked={includeArchived} onChange={(e) => setIncludeArchived(e.target.checked)} />}
                        label="Visa arkiverade"
                    />
                    <Button variant="contained" color="secondary" onClick={() => history.push("/offers/create")}>
                        Nytt erbjudande
                    </Button>
                </div>
                {loading && <CircularProgress color="secondary" />}
                {!loading && offers &&
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Namn</TableCell>
                                <TableCell>Arkiverad</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {offers.map((o) => (
                                <TableRow key={o.id} hover style={{ cursor: "pointer" }} onClick={() => history.push(`/offers/manage/${o.id}`)}>
                                    <TableCell>{o.name}</TableCell>
                                    <TableCell>{o.isArchived ? "Ja" : ""}</TableCell>
                                    <TableCell align="right"><IconButton size="small"><Edit /></IconButton></TableCell>
                                </TableRow>
                            ))}
                            {offers.length === 0 &&
                                <TableRow><TableCell colSpan={3}>Inga erbjudanden</TableCell></TableRow>
                            }
                        </TableBody>
                    </Table>
                }
            </CardContent>
        </Card>
    );
};

export default ManageOffers;
